<template>
    <section>
        <div class="table_overflow">
          <table class="vypis vypis_detail" ref="table_with_action_line" v-show="dataLoaded">
              <not-sorting-table-header
                      :titles="sortingTableTitles"
                      :checkbox="true"
                      :drag-drop="true"
                      :use-right="false">
              </not-sorting-table-header>
              <tbody>
              <cron-run-row
                      v-for="entity in entities"
                      :entity="entity"
                      :key="entity.id"
                      :selectedEntities="selectedEntities"
                      @input="select"
              ></cron-run-row>
              </tbody>
          </table>
        </div>
        <list-action-line
                :entities="entities"
                :offset="formFields.offset"
                :limit="formFields.limit"
                :total-count="totalCount"
                :selected-entities="selectedEntities"
                :multiple-action-options="multipleActionOptions"
                @select-all="toggleSelectAll"
                @run-multiple-action="runMultipleAction"
                @limit="setLimit"
                @offset="setOffset"
                ref="action_line"
        ></list-action-line>
    </section>
</template>

<script>
	import listActions from "@/components/mixins/list-actions"
	import CronRunRow from "@/components/views/crons/CronRunRow"
	import NotSortingTableHeader from "@/components/common/NotSortingTableHeader"

	export default {
		name: "CronRunList",
		components: {NotSortingTableHeader, CronRunRow},
		mixins: [listActions],
		data() {
			return {
				moduleName: 'runs',
        formFields: {
					limit: 10
        }
			}
		},
    computed: {
      sortingTableTitles(){
        return [
          this.$gettext('Začátek'),
          this.$gettext('Konec'),
          this.$gettext('Status'),
          this.$gettext('Výsledek'),
        ];
      },
      multipleActionOptions() {
        return [
          {value: 'choose', text: this.$gettext('Vyberte akci')},
          {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
        ]
      },
      csvHeaders(){
        return {
          start_timestamp: { name: this.$gettext('Začátek'), callback: entity => { return this.$_datetime_format(entity.start_timestamp)}},
          end_timestamp: { name: this.$gettext('Konec'), callback: entity => { return this.$_datetime_format(entity.end_timestamp)}},
          status: { name: this.$gettext('Status')},
          result: { name: this.$gettext('Úspěch'), callback: entity => { return entity.result === 'ok' ? this.$gettext('Ano') : this.$gettext('Ne')}}
        }
      },
    },
		created(CronService) {
			this.entityService = CronService
			this.createdInit()
		},
		methods: {
			getEntities() {
				this.setLoadingMessage()
				this._processGetEntitiesResponse(this.entityService.getCronRuns(this.$route.params.id, this.getFormFields()))
			},
      _exportCsv() {
        this.setLoadingMessage()
        let formFields = this._processFormFields(this.getFormFields());
        delete formFields.limit;
        delete formFields.offset;
        this._processGetEntitiesCsvResponse(this.entityService.getCronRuns(this.$route.params.id, formFields), this.csvHeaders)
      }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/crons/CronRunList.vue